module.exports = __webpack_public_path__ + "img/app02.png";